/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { ajax, Status, getState, arrayFrom, publish } from '../../../twd/twd'
import { getAuth } from '../use-bitvore'

const state = getState('corporates.market-news.use-search-manual', {})

export default () => {
    const [keyword, setKeyword] = React.useState('')
    const [entered, setEntered] = React.useState(false)
    const [status, setStatus] = React.useState(Status.LOADING)
    const [searchResults, setSearchResults] = React.useState([])

    const timerId = React.useRef()
    const lastKeyword = React.useRef(state.value.lastKeyword)
    const lastAbort = React.useRef()

    React.useEffect(() => {
        if (timerId.current) {
            clearTimeout(timerId.current)
            timerId.current = 0
        }

        var dismounted = false
        setSearchResults([])

        timerId.current = setTimeout(async () => {
            if (!keyword) return
            if (lastKeyword.current === keyword && searchResults.length>0) {
                if (entered) {
                    publish('corporate-market-news-custom-search-entered', searchResults[0])
                    setEntered(false)
                }
                return
            }

            state.set({lastKeyword: keyword})
            setStatus(Status.LOADING)
            lastKeyword.current = keyword

            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                let auth = await getAuth()
                let { data, abort } = await ajax({
                    url: 'https://api.bitvore.com/entityapi/entities',
                    method: 'GET',
                    headers: {
                        ...auth
                    },
                    isDc: false,
                    params: {
                        lookup: keyword.trim(),
                        pageSize: 10
                    }
                })

                lastAbort.current = abort
                let a = await data
                if (dismounted) return

                let rs = arrayFrom(a.response)
                setSearchResults(rs)
                setStatus(Status.LOADED)
                if (entered && rs.length>0) {
                    publish('corporate-market-news-custom-search-entered', rs[0])
                    setEntered(false)
                }
            } catch(e) {
                if (dismounted) return

                setSearchResults([])
                setStatus(Status.FAILED_TO_LOAD)
            }
        }, 500)

        return () => {
            dismounted = true

            if (lastAbort.current) {
                lastAbort.current()
                lastAbort.current = null
            }
            if (timerId.current) {
                clearTimeout(timerId.current)
                timerId.current = 0
            }
        }

    }, [keyword, entered])

    return { keyword, setKeyword, status, searchResults, setEntered}
}